<template>
    <Button style="background-color: #3B5998;" class="ph2 cf" @click="$emit('click')">
        <img class="fl" src="@/assets/img/icon_facebook.svg"/>
        <span class="white center">
            <slot></slot>
        </span>
    </Button>
</template>

<script>
import Button from '@/components/buttons/Button.vue';

export default {
    components: {
        Button
    }
};
</script>
